<template>
  <div id="app">
    <div class="socials">
        <a href="https://www.behance.net/BlackPugStudio" class="social be" target="_blank" data-text="Follow us on Behance" rel="nofollow">
            <i></i>
            <span class="text"></span>
        </a>
        <a href="https://twitter.com/BlackPugStudio" target="_blank" class="social tw" data-text="Follow us on Twitter" rel="nofollow">
            <i></i>
            <span class="text"></span>
        </a>
        <a href="https://www.instagram.com/blackpugstudio/" target="_blank" class="social ist" data-text="Follow us on Instagram" rel="nofollow">
            <i></i>
            <span class="text"></span>
        </a>
        <a href="https://medium.com/@blackpugstudio" target="_blank" class="social med" data-text="Follow us on Medium" rel="nofollow">
            <i></i>
            <span class="text"></span>
        </a>
    </div>

    <div v-if="invoice" class="container" :paid="!loading && invoice.paid">
        <div class="box left">
            <div class="invoice-date">{{invoice.date}}</div>
            <img class="logo" src="/images/bps_logo.svg" alt="Black Pug Studio Limited">
            <div class="page-title">// { Online payment }</div>
            <div class="invoice-ref">Invoice reference #{{invoice.id}}</div>
            <div class="invoice-info">
                <b>{{invoice.title}}</b>
                <p>You should have received a *.pdf version of your invoice containing individual services charge details. If you have not received your printable invoice, please contact us at <a href="mailto:contact@blackpugstudio.com" rel="nofollow">contact@blackpugstudio.com</a></p>
            </div>
        </div>
        <div class="box right">
            <h1>Invoice #{{invoice.id}}</h1>
            <div class="iframe-container" :processing="loading">
                <form id="paymentForm" @submit.prevent="submitPayment">
                    <input v-model="paymentModel.name" id="name" type="text" placeholder="Name" name="name" required>
                    <input v-model="paymentModel.email" id="email" type="email" placeholder="Email" name="email" required>
                    <div id="card"></div>
                    <div id="cardErrors" role="alert" v-if="error">{{error}}</div>
                    <button type="submit">Pay now</button>
                </form>
                <div class="processing">
                    <span>Processing...</span>
                </div>
                <div class="success">
                    <h2>Thank you</h2>
                    <div>Payment successfully completed!</div>
                    <div>You should receive an email confirmation including your receipt.</div>
                    <div class="paid-btn"><i class="ic check"></i>&nbsp;Paid</div>
                </div>
            </div>
            <div class="breakdown">
                <div class="amount">
                    <label>Total excl. VAT</label>
                    <span class="price">€{{formatPrice(invoice.total_excl)}}</span>
                </div>
                <div class="amount">
                    <label>VAT 23%</label>
                    <span class="price">€{{formatPrice(invoice.vat)}}</span>
                </div>
                <div class="amount" v-if="invoice.payment_fees">
                    <label>Stripe payment fees</label>
                    <span class="price">€{{formatPrice(invoice.payment_fees)}}</span>
                </div>
                <div class="amount total">
                    <label>Total</label>
                    <span class="price">€{{formatPrice(invoice.amount)}}</span>
                </div>
            </div>
        </div>
    </div>

    <footer>
        <img src="/images/powered_by_stripe.svg" alt="Powered by Stripe" class="stripe">
        <div>Black Pug Studio online payments are secured and powered by Stripe!</div>
        <div>This is an SSL-protected area. Our trusted Firebase SSL certificate protects your sensitive information by encrypting
            the data you send to us.</div>
        <div class="copyright">© {{year}} - Black Pug Studio Limited - All rights reserved</div>
    </footer>
  </div>
</template>

<script>
/* global Stripe */
import Vue from 'vue'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database'
import 'firebase/compat/functions'

firebase.initializeApp({
  apiKey: "AIzaSyAKrffb-FO-g3I6smTDVVI8VR0TYBuLsDA",
  authDomain: "paysys-bad75.firebaseapp.com",
  databaseURL: "https://paysys-bad75.firebaseio.com",
  projectId: "paysys-bad75",
  storageBucket: "",
  messagingSenderId: "600504951563"
})

export default {
  name: 'app',
  components: {
    
  },
  data() {
    return {
      year: new Date().getFullYear(),
      invoice: null,
      paymentModel: {
        email: '',
        name: ''
      },
      loading: false,
      error: null,
      stripe: null,
      card: null
    }
  },
  methods: {
    getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    formatPrice(p) {
      if(isNaN(p)) return "0.00"
      return parseFloat(p).toFixed(2)
    },
    submitPayment() {
      this.loading = true
      this.stripe.createPaymentMethod('card', this.card, {
        billing_details: {
            name: this.paymentModel.name,
        }
      })
      .then(data => {
        if(data.error) throw data.error
        else {
          return firebase.functions().httpsCallable('submitPayment')({
            id: this.invoice.id,
            email: this.paymentModel.email,
            token: data.paymentMethod.id
          })
        }
      })
      .then(({data}) => {
        if(data.success) return {data}
        if(data.requires_action) {
            return this.stripe.handleCardAction(data.client_secret)
            .then(result => firebase.functions().httpsCallable('submitPayment')({
                id: this.invoice.id,
                email: this.paymentModel.email,
                payment: result.paymentIntent.id
            }))
        }
        throw new Error('We could not process your payment.')
      })
      .then(({data}) => {
        if(!data.success) throw new Error('We could not process your payment.')
        this.error = null
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.error = err ? err.message || err : 'Unknow error'
      })
    }
  },
  mounted: function() {
    const i = this.getParameterByName('i');
    const preview = this.getParameterByName('preview')
    firebase.database().ref(`/invoices/${i}/info`)
      .on('value', v => {
        if(!preview && !this.invoice && v.exists()) {
          firebase.database().ref(`/invoices/${i}/analytics/pageviews`).push({
            timestamp: firebase.database.ServerValue.TIMESTAMP,
            navigator: window.navigator.userAgent
          })
        }
        this.invoice = v.val() || null
        if(!this.invoice) return
        Vue.nextTick().then(() => {
          this.stripe = Stripe(this.invoice.test ? 'pk_test_GDEz4mI1Yge7AA6PcQgaMQUB' : 'pk_live_LFH1vGfsg8MWUfZ57mV9OVbI')
          const elements = this.stripe.elements()
          this.card = elements.create('card', {
            style: {
              base: {
                color: '#32325d',
                lineHeight: '12px',
                fontFamily: '"Runda", "Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '14px',
                '::placeholder': {
                  color: 'rgba(34,31,31, .77)'
                }
              },
              invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
              }
            },
            hidePostalCode: true
          })
          this.card.mount(document.querySelector('#card'))
        })
      })

    var socials = document.querySelectorAll('a.social'),
    timeouts = [];

    function addChar(c, char, i) {
        return setTimeout(function () {
            c.innerHTML += char
        }, i * 40);
    }

    socials.forEach(function (s) {
        s.addEventListener('mouseenter', () => {
            var c = s.querySelector('.text');
            timeouts.forEach(function (t) {
                clearTimeout(t)
            });
            timeouts = [];
            c.innerHTML = "";
            timeouts.push(setTimeout(function () {
                var text = s.getAttribute('data-text');
                if (text) {
                    for (var i = 0; i < text.length; i++) {
                        timeouts.push(addChar(c, text[i], i));
                    }
                }
            }, 240))
        })
    })
  }
}
</script>

<style>
a {
    text-decoration: none;
}

.container {
    position: absolute;
    left: 0;
    right: 0;
    width: 1036px;
    /* -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    top: 50%; */
    top: 22.5vh;
    margin: auto;
}

.box {
    box-sizing: border-box;
    position: relative;
    border-radius: 8px;
}

.box.left {
    width: 336px;
    margin-right: 48px;
}

.box.left a {
    color: #A1AF3E;
    text-decoration: underline;
}

.box.right {
    padding: 24px 32px;
    width: 400px;
    height: 425px;
    background: #fff;
    color: #221f1f;
}

.box.right:after {
    content: '';
    position: absolute;
    left: 100%;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 250px;
    height: 360px;
    background: url(/images/bps_bg_payment_2x.png) no-repeat center;
    background-size: cover;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    box-shadow: inset 19px 0 26px rgba(34,31,31, .1);
}

.box.left,
.box.right {
    display: inline-block;
    vertical-align: middle;
}

.box.paid {
    display: none;
    text-align: center;
}

.invoice-date {
    margin-bottom: 16px;
    color: rgba(250,250,250, .77);
}

.invoice-info b {
    font-size: 12px;
    color: rgba(250,250,250, 1);
}

.invoice-info p {
    margin: 0;
    font-size: 12px;
    line-height: 20px;
}

.invoice-ref {
    margin: 16px 0 12px;
    color: rgba(250,250,250, .77);
    font-size: 12px;
}

[loading] .box {
    display: none;
}

h1 {
    margin: 0 0 24px;
    text-transform: uppercase;
    letter-spacing: 1.8px;
    font-size: 18px;
    text-align: center;
    position: relative;
}

h1:after {
    content: '';
    display: block;
    width: 36px;
    height: 2px;
    background: #A1AF3E;
    margin: 4px auto 0;
}

form {
    text-align: center;
}

form button {
    margin-top: 12px;
    background: #A1AF3E;
    color: #fff;
    font: bold 18px/1 'Segoe UI';
    letter-spacing: 2px;
    border: none;
    height: 60px;
    text-transform: uppercase;
    cursor: pointer;
    outline: none;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}

#card,
input {
    border: none;
    border-bottom: 1px solid rgba(34,31,31, .12);
    padding: 8px 0;
    background: #fff;
}

input {
    padding: 0;
    height: 28px;
    box-sizing: border-box;
    display: block;
    width: 100%;
    margin-bottom: 8px;
    font: inherit;
    font-size: 14px;
    color: inherit;
    outline: none;
}

#cardErrors {
    margin-top: 12px;
    color: #ea2c3c;
    font-weight: bold;
    font-size: 12px;
}

[paid] #paymentForm {
  display: none;
}

::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color: #221f1f;
    opacity: .77;
    text-transform: uppercase;
}
::-moz-placeholder { /* Firefox 19+ */
    color: #221f1f;
    opacity: .77;
    text-transform: uppercase;
}
:-ms-input-placeholder { /* IE 10+ */
    color: #221f1f;
    opacity: .77;
    text-transform: uppercase;
}
:-moz-placeholder { /* Firefox 18- */
    color: #221f1f;
    opacity: .77;
    text-transform: uppercase;
}

img.logo {
    width: 100%;
    display: block;
    margin-bottom: 16px;
}

.page-title {
    font-size: 18px;
    position: relative;
    color: rgba(250,250,250, .77);
}

.page-title:after {
    content: '';
    position: absolute;
    top: 14px;
    bottom: 0;
    right: 0;
    left: 175px;
    height: 2px;
    background: #fafafa;
}

.breakdown .price {
    float: right;
    margin-left: 24px;
    padding-left: 8px;
}

.iframe-container {
  min-height: 150px;
}

.breakdown {
    font-weight: 300;
    margin-top: 8px;
}

.breakdown label {
    padding-right: 8px;
}

.breakdown label,
.breakdown .price {
    background: #fff;
    position: relative;
    z-index: 1;
}

.breakdown .amount {
    position: relative;
    line-height: 1;
    margin-bottom: 12px;
}

.breakdown .amount:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 1px;
    height: 1px;
    background: #221f1f;
    opacity: .12;
}

.breakdown .total {
    font-weight: 400;
    text-transform: uppercase;
    text-align: center;
    margin-top: 16px;
}

.breakdown .total:after {
    display: none;
}

.breakdown .total label {
    font-size: 10px;
    display: block;
    padding: 0;
    letter-spacing: 1.8px;
}

.breakdown .total .price {
    font-size: 20px;
    float: none;
    padding: 0;
    margin: 6px 0 0;
    display: block;
    letter-spacing: 3.2px;
}

.iframe-container .success {
    display: none;
}

[paid] .iframe-container .success {
    display: block;
    padding: 8px 32px 0;
    text-align: center;
    font-size: 16px;
}

[paid] .iframe-container .success h2 {
    text-transform: uppercase;
    margin: 0;
    font-size: 28px;
    color: #A1AF3E;
}

.iframe-container .success .paid-btn {
    position: absolute;
    background: #A1AF3E;
    color: #fff;
    text-align: center;
    line-height: 60px;
    bottom: 0;
    left: 0;
    right: 0;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-size: 18px;
}

.iframe-container .processing {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255,255,255, .72);
    display: none;
    z-index: 11;
}

.iframe-container[processing] {
    z-index: 10;
}

.iframe-container[processing] .processing {
    display: block;
}

.iframe-container .processing span {
    height: 90px;
    line-height: 24px;
    font-size: 24px;
    text-transform: uppercase;
    letter-spacing: 1.8px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    text-align: center;
}

footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 24px;
    text-align: center;
    font-size: 12px;
    font-weight: 300;
    line-height: 1.5;
    color: rgba(250,250,250, .77);
}

footer .copyright:before {
    content: '';
    display: block;
    width: 60px;
    height: 1px;
    background: #fafafa;
    opacity: .12;
    margin: 12px auto;
}

footer .stripe {
    height: 20px;
    margin-bottom: 4px;
}

i.ic {
    display: inline-block;
    width: 24px;
    height: 24px;
    background-size: 24px 24px;
    background-position: center;
    background-repeat: no-repeat;
    vertical-align: text-bottom;
}

i.ic.check {
    background-image: url(/images/bps_i_check.svg);
}

.socials {
    position: absolute;
    top: 36px;
    left: 24px;
}

.socials .social {
    display: block;
    margin-bottom: 20px;
    color: transparent;
    -webkit-transition: color .16s;
    transition: color .16s;
}

.socials .social:before,
.socials .social:after {
    display: inline-block;
    -webkit-transition: transform .16s ease-out .08s;
    transition: transform .16s ease-out .08s;
}

.socials .social:before {
    content: '{';
    -webkit-transform: translateX(-20px);
    transform: translateX(-20px);
}

.socials .social:after {
    content: '}';
    padding-left: 10px;
    -webkit-transform: translateX(20px);
    transform: translateX(20px);
}

.socials .social:hover:before,
.socials .social:hover:after {
    -webkit-transform: none;
    transform: none;
}

@media all and (min-width: 1025px) {
    .socials .social:hover {
        color: #fafafa;
    }
}

.socials .social i {
    display: inline-block;
    width: 18px;
    height: 16px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    vertical-align: text-bottom;
    margin: 0 10px;
}

.socials .social.tw i {
    background-image: url(/images/bps_i_twitter.svg);
    width: 16px;
    height: 14px;
}

.socials .social.be i {
    background-image: url(/images/bps_i_behance.svg);
}

.socials .social.ist i {
    background-image: url(/images/bps_i_instagram.svg);
}

.socials .social.med i {
    background-image: url(/images/bps_i_medium.svg);
}
</style>
